import { TFunction } from 'i18next'

export const apiResponseMessages : { [key: string]: string, } = {
  '403 FORBIDDEN': 'Invalid otp provided',
  '401 UNAUTHORIZED': 'Invalid credentials',
  'ACCOUNT_LOCKED':'Your account is locked, contact support',
  'SOMETHING_WENT_WRONG': 'Something went wrong',
  'BAD_CREDENTIALS': 'Invalid credentials',
  'EMAIL_SENT_SUCCESSFULLY': 'Statement has been sent to your email',
  'BENEFICIARY_CREATED' : 'Your beneficiary was created successfully',
  'BENEFICIARY_UPDATED' : 'Your beneficiary was updated successfully',
  'BENEFICIARY_PENDING' : 'Your beneficiary was created and was sent for approval',
  'INVALID_REQUEST_FORMAT_FOR_BILL_PAYMENT': 'Beneficiary creation failed, please try again later',
  'NON_MIGRATED_CUSTOMER_NOT_ALLOWED' : 'Non migrated customer',
  'USERNAME_ALREADY_TAKEN' : 'Username already taken, try another one',
  'INVALID_REQUEST_FORMAT_FOR_BK_TO_MTN_WALLET ' : 'Invalid request format',
  'PENDING_APPLICATION_FOUND': 'Your application is under processing',
  'Cannot invoke \"String.hashCode()\" because \"this.gender\" is null' : 'User has no assigned gender, contact customer support',
  'WELL_SUCCESSFUL_UPDATED' : 'Favourite billers, updated successfully',
  'WRONG_OTP': 'Invalid otp provided',
  '404 NOT_FOUND': 'Resource not found',
  'PHONE_NUMBER_NOT_FOUND': 'Phone number not found',
  'NOT_FOUND': 'Resource not found',
  'ERROR_SAVING_RSSB': 'An error occurred, please try again',
  'RSSB_NUMBER_MISMATCH_WITH_LEGAL_DOCUMENT': 'RSSB number mismatch with legal document',
  'ID_NOT_FOUND_IN_RSSB': 'RSSB number not found',
  'CUSTOMER_HAS_NO_CONSENT': 'Failed to verify RSSB consent! Ensure you have given consent on RSSB and try again in a moment',
  'CALL_TO_RSSB_FAILED': 'Call to RSSB failed! Try again in a moment',
  'USER_DISABLED': 'User disabled',
  'UNAUTHORIZED_VIEW_BALANCE': 'You are not authorized to view this account balance',
  '(NOT_FOUND) ACCOUNT_NOT_FOUND' : 'Invalid account number',
  'KASHA_UNAUTHORIZED_ACCOUNT' : 'Go to ‘Pay’ and use a Bill ID to buy from Kasha',
  '(NOT_FOUND) CBS_NOT_FOUND': 'Account not found',
  'RSSB_CONTRIBUTION_IN_LAST_2_MONTHS_REQUIRED': 'Dear Customer, your recent RSSB contributions were not found. Please contact your employer or RSSB. For help, call 4455',
  'THIS_LOAN_REQUIRES_RSSB_CONTRIBUTION': 'Dear Customer, your recent RSSB contributions were not found. Please contact your employer or RSSB. For help, call 4455',
  'ERROR_CALLING_ESB': 'Error validating this bill ID, please try again later',
  'USER_ALREADY_MIGRATED': 'User already migrated',
  'USER_ALREADY_MIGRATED_AND_USERNAME_CHANGED': 'User already migrated and username changed',
  'USER_ALREADY_MIGRATED_ON_THE_SAME_CUSTOMER': 'User already migrated on the same customer',
  'CHANNEL_NOT_ACTIVE': 'Channel not active, contact support',
  'Channel deactivated! Please contact customer service': 'Channel deactivated! Please contact customer service',
  '423 LOCKED': 'Your account is locked, contact support',
  'INSUFFICIENT_BALANCE': 'You have insufficient balance to perform this transaction',
  'BILL_ID_NOT_FOUND': 'Bill ID not found',
  'DISBURSEMENT_ACCOUNT_NOT_CURRENT_OR_CURRENCY_MISMATCH_OR_NOT_FOUND_FOR_CUSTOMER': 'Disbursement account not current or currency mismatch or not found for customer',
  'WRONG_PASSWORD': 'Wrong old password provided',
  'PASSWORD_USED': 'You have used this password recently, please try another one',
  'UNAUTHORIZED_CREATE_BENEFICIARY': 'You don\'t have permissions to create a beneficiary',
  'UNAUTHORIZED_UPDATE_BENEFICIARY': 'You don\'t have permissions to update a beneficiary',
  'PERMISSION_DENIED_BENEFICIARY': 'You don\'t have permissions to delete a beneficiary',
  'BENEFICIARY_PENDING_EXISTS': 'There is already a pending beneficiary for approval',
  'UNAUTHORIZED_ACCESS': 'You are not authorized to access this resource',
  'ACCOUNT_NOT_FOUND': 'Account not found',
  'SIM_SWAP_NOT_PERMITTED': 'Recent SIM swap detected, contact support for assistance',
  'BILL_ID_ALREADY_PAID': 'This Bill ID has already been paid',
  'BILL_ID_EXPIRED': 'The Bill ID has expired, kindly provide a valid one',
  'Cannot cast java.lang.String to java.util.UUID': '',
  'BILL_ID_NOT_FOUND_OR_EXPIRED': 'Bill ID not found or expired',
  'INVALID_BILL_ID': 'The Bill ID you have entered is invalid, kindly check it and try again',
  'CUSTOMER_HAS_ARREARS_IN_CRB': 'Customer has arrears in CRB',
  'CRB_CHECK_FAILED': 'CRB check failed',
  'LOW_SCORE': 'Customer has low score',
  'CUSTOMER_OR_ACCOUNT_NOT_ALLOWED_BKQUICK': 'Customer or account not allowed BKQuick',
  'PAYER_CODE_NOT_FOUND': 'Payer code not found',
  'CUSTOMER_SHOULD_HAVE_CLEAN_CRB_REPORT': 'Customer should have a clean crb report',
  'CUSTOMER_NUMBER_NOT_PRESENT': 'cards.error.creation.customer_number_not_present',
  'CUSTOMER_NOT_FOUND': 'cards.error.creation.customer_not_found',
  'NO_PERMISSION_TO_CREATE_VIRTUAL_CARD': 'cards.error.creation.no_permission',
  'CURRENCY_MISMATCH': 'cards.error.creation.currency_mismatch',
  'VIRTUAL_CARD_AMOUNT_OR_CURRENCY_NOT_SUPPORTED': 'cards.error.creation.amount_or_currency_not_supported',
  'VIRTUAL_CARD_CREATION_LIMIT_EXCEEDED': 'cards.error.creation.limit_exceeded',
  'CURRENCY_NOT_SUPPORTED': 'cards.error.creation.currency_not_supported',
  'ACCOUNT_NOT_PERMITTED_TO_INITIATE_VIRTUAL_CARD_CREATION': 'cards.error.creation.account_not_permitted'


}

export const defaultErrorMessage = 'Something went wrong, please try again!'

interface ApiError {
  data?: {
    error?: string,
    message?: string,
  },
}

// Backend messages that carry dynamic values; only matched messages are shown
export const apiResponsePatterns: { pattern: RegExp, message: (match: RegExpMatchArray, t: TFunction) => string, }[] = [
  {
    pattern: /^Amount mismatch:\s*expected=([\d.]+),\s*received=([\d.]+)$/,
    message: (match, t) => t('payments.error.amount_mismatch', { expected: match[1], received: match[2] }),
  },
]

// Unknown messages (raw SQL or system errors) fall back to the default message
export const getApiErrorMessage = (apiError: ApiError | undefined, t: TFunction): string => {
  const message = apiError?.data?.message?.trim() || ''
  const code = apiError?.data?.error?.trim() || ''

  if (apiResponseMessages[message]) return t(apiResponseMessages[message])

  for (const { pattern, message: format } of apiResponsePatterns) {
    const match = message.match(pattern)
    if (match) return format(match, t)
  }

  if (apiResponseMessages[code]) return t(apiResponseMessages[code])

  return t(defaultErrorMessage)
}
